<i-alert-circle></i-alert-circle>
<div class="text">
    <ng-content></ng-content>
</div>
